// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1181":"36a628d5","2497":"36a628d5","3227":"4ffbfa37","4557":"a37629d0","4985":"36a628d5","5785":"36a628d5","6232":"36a628d5","8646":"36a628d5"}[chunkId] + ".chunk.css";
};